<div class="toolbar-item account">

  @if (customerService.isLoggedIn()) {
    <a
      class="account-link"
      [routerLink]="['/', 'account']"
      routerLinkWithLang
    >
      <i class="toolbar-item-icon mbi mbi-user"></i>
      <div class="account-login-text">{{ customerService.customer().contactInfo.firstName }}</div>
    </a>
  } @else {
    <button
      class="account-link"
      type="button"
      (click)="onLoginClick()"
    >
      <i class="toolbar-item-icon mbi mbi-user"></i>
      <span class="account-login-text">{{ 'global.to_login' | translate }}</span>
    </button>
  }

  @if (customerService.isLoggedIn()) {
    <ul class="account-menu">
      <li>
        <a
          class="account-menu-link"
          [routerLink]="['/', 'account']"
          routerLinkWithLang
        >
          {{ 'global.my_account' | translate }}
        </a>
      </li>
      <li>
        <a
          class="account-menu-link"
          [routerLink]="['/', 'cart']"
          routerLinkWithLang
        >
          {{ 'mini_account.my_cart' | translate }}
        </a>
      </li>
      <li>
        <a
          class="account-menu-link"
          [routerLink]="['/', 'account', 'orders']"
          routerLinkWithLang
        >
          {{ 'global.my_orders' | translate }}
        </a>
      </li>
      <li>
        <a
          class="account-menu-link"
          (click)="logout()"
        >
          {{ 'mini_account.logout' | translate }}
        </a>
      </li>
    </ul>
  }
</div>
